import controller from './vd-error-message.controller'
import template from './vd-error-message.html'

const vdErrorMessageComponent = {
  template,
  transclude: true,
  controller,
}

export default vdErrorMessageComponent
